import { ErrorMessageComponent } from "@/features/api/domain/ErrorMessageComponent";
import { Text } from "@meditect/medibase-components";

// biome-ignore lint/complexity/noBannedTypes: <explanation>
export const PrivateProductLabelAlreadyExistInReferentielError: ErrorMessageComponent<{}> = () => {
  return (
    <Text as="span" mr={1}>
      Ce label de produit existe déjà dans le référentiel, veuillez choisir le produit du référentiel plutôt que de
      créer un nouveau produit.
    </Text>
  );
};
